import EFPicture from '@elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';
import gtm from 'eco-design-reliance/gtm';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import { getSolarRecommand2 } from '@/service/solar-calculator';

let maskScene: any = null;
export default function W() {
    const { useLang, useEffect, useState, Link } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [gap, setGap] = useState(24);
    const { useRouter } = useGlobal();
    const { locale } = useRouter();

    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        const resizeAni = () => {
            if (maskScene) AniContainer.removeScene(maskScene);

            const clientH = (window.innerHeight || 0) * 0.2;
            const startH = Math.min(clientH, 150);
            maskScene = AniContainer.create({
                triggerElement: '.dpu-detail-W',
                triggerHook: 1,
                offset: startH,
                duration: 1200, //window.innerHeight * 2,
                onEnter: () => {
                    setTextEnter(true);
                },
                //onLeave: () => setTextEnter(false),
            });
        };
        resizeAni();
    }, []);

    let cards: any[] = [
        {
            productId: '8012436242586',
            variantId: '44244769308826',
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703676435-1339bu-compressed-delta%20pro%403x.png',
            name: t('secW_card1_name'),
            link: t('secW_card1_link'),
        },
        {
            productId: '8012436275354',
            variantId: '44300036636826',
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703704982-13q36h-compressed-delta%20pro%403x.png',
            name: t('secW_card2_name'),
            link: t('secW_card2_link'),
        },
        {
            productId: '8012436308122',
            variantId: '44300047909018',
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703722911-94pxe4-compressed-delta%20pro%403x.png',
            name: t('secW_card3_name'),
            link: t('secW_card3_link'),
        },
        {
            productId: '8012436340890',
            variantId: '44244769407130',
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703746573-y2qbhi-compressed-delta%20pro%403x.png',
            name: t('secW_card4_name'),
            link: t('secW_card4_link'),
        },
        // {
        //     img: '/responsive/picture/common-products/Dongle_PPS_4G.png',
        //     name: t('secW_card5_name'),
        //     link: t('secW_card5_link'),
        // },
        {
            productId: '8012436603034',
            variantId: '44300038766746',
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703768902-aq8ve6-compressed-delta%20pro%403x.png',
            name: t('secW_card6_name'),
            link: t('secW_card6_link'),
        },
    ];
    if (['us'].includes(locale)) {
        cards = [
            {
                productId: '6965707407433',
                variantId: '40758559408201',
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703676435-1339bu-compressed-delta%20pro%403x.png',
                name: t('secW_card1_name'),
                link: t('secW_card1_link'),
            },
            {
                productId: '6965708128329',
                variantId: '40758561144905',
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703704982-13q36h-compressed-delta%20pro%403x.png',
                name: t('secW_card2_name'),
                link: t('secW_card2_link'),
            },
            {
                productId: '6965708685385',
                variantId: '40758561964105',
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703722911-94pxe4-compressed-delta%20pro%403x.png',
                name: t('secW_card3_name'),
                link: t('secW_card3_link'),
            },
            {
                productId: '6967949819977',
                variantId: '40767961530441',
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703746573-y2qbhi-compressed-delta%20pro%403x.png',
                name: t('secW_card4_name'),
                link: t('secW_card4_link'),
            },

            {
                productId: '6967995105353',
                variantId: '40768194904137',
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703768902-aq8ve6-compressed-delta%20pro%403x.png',
                name: t('secW_card6_name'),
                link: t('secW_card6_link'),
            },
        ];
    }
    if (['au'].includes(locale)) {
        cards = [
            {
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703676435-1339bu-compressed-delta%20pro%403x.png',
                name: t('secW_card1_name'),
                link: t('secW_card1_link'),
            },
            {
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703704982-13q36h-compressed-delta%20pro%403x.png',
                name: t('secW_card2_name'),
                link: t('secW_card2_link'),
            },
            {
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703722911-94pxe4-compressed-delta%20pro%403x.png',
                name: t('secW_card3_name'),
                link: t('secW_card3_link'),
            },
            {
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703746573-y2qbhi-compressed-delta%20pro%403x.png',
                name: t('secW_card4_name'),
                link: t('secW_card4_link'),
            },
            {
                img: 'https://websiteoss.ecoflow.com/figma-uploads/1784703768902-aq8ve6-compressed-delta%20pro%403x.png',
                name: t('secW_card6_name'),
                link: t('secW_card6_link'),
            },
        ];
    }

    const [cardList, setCardList] = useState(cards);

    useEffect(() => {
        let canceled = false;
        const getCardsInfo = async () => {
            const variantIds = cards.map((card: any) => card?.variantId).filter(Boolean);
            if (variantIds.length <= 0) {
                setCardList(cards);
                return;
            }
            try {
                const res = await getSolarRecommand2({ variantIds }, locale);
                if (res?.code === '0' && Array.isArray(res?.data)) {
                    const productMap = res.data.reduce((map: Record<string, any>, item: any) => {
                        if (item?.variantId) {
                            map[item.variantId] = item;
                        }
                        return map;
                    }, {});

                    const results = cards
                        .map((card: any) => {
                            if (!card?.variantId) return card;

                            const productInfo = productMap[card.variantId];
                            // 批量接口成功但没有返回该变体，视为已下架
                            if (!productInfo) return null;

                            const isSoldOut = Number(productInfo?.inventoryQuantity || 0) <= 0 && productInfo?.inventoryPolicy !== 'continue';
                            return {
                                ...card,
                                inventoryQuantity: productInfo?.inventoryQuantity,
                                inventoryPolicy: productInfo?.inventoryPolicy,
                                isSoldOut,
                            };
                        })
                        .filter(Boolean);

                    if (!canceled) {
                        setCardList(results);
                    }
                }
            } catch (error) {
                console.error(error);
            }
        };
        getCardsInfo();
        return () => {
            canceled = true;
        };
        // cards is rebuilt from locale/t on render; tracking locale is enough for product info refresh.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locale]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resize = () => setGap(window?.innerWidth >= 1440 ? 24 : window?.innerWidth >= 768 ? 20 : 12);
            resize();
            //window?.addEventListener('resize', resize);
            //return () => window.removeEventListener('resize', resize);
        }
    }, []);

    return (
        <section className={`dpu-detail-W tt dpu-detail-section ${textEnter ? 'textEnter' : ''} ${css['dpu-detail-W']}`}>
            <EfSpec />
            <h2 className="title">{t('secW_title')}</h2>
            <Swiper
                className="cards swiper-box"
                modules={[Navigation]}
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation={{
                    nextEl: '.swiper-btns .swiper-next',
                    prevEl: '.swiper-btns .swiper-prev',
                }}
            >
                {cardList?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <div className="card-img">
                            <EFPicture src={card?.img} alt={card?.name} />
                        </div>
                        <p className={`card-name`}>{card?.name}</p>
                        {card?.isSoldOut ? (
                            <button type="button" disabled className="card-link disable">
                                {t('sold_out')}
                            </button>
                        ) : (
                            <Link
                                className="card-link"
                                href={card?.link}
                                target={card?.link?.startsWith('http') ? '_blank' : '_self'}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'buy',
                                    product_name: card?.name,
                                    position: 'Product Detail_Accessories ',
                                }}
                            >
                                {t('common_learn_more')}
                            </Link>
                        )}
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="swiper-btns">
                <div
                    className="swiper-prev tab GtmModuleData-btn-common"
                    data-btn-id="accessories-prev"
                    onClick={() => {
                        gtm.push({
                            __btn_id1: `dpu-Accessories .swiper-prev`,
                            __btn_id2: `accessories-prev`,
                            __btn_type: 'common',
                        });
                    }}
                >
                    <EcoIconArrow />
                </div>
                <div
                    className="swiper-next GtmModuleData-btn-common"
                    data-btn-id="accessories-next"
                    onClick={() => {
                        gtm.push({
                            __btn_id1: `dpu-Accessories .swiper-next`,
                            __btn_id2: `accessories-next`,
                            __btn_type: 'common',
                        });
                    }}
                >
                    <EcoIconArrow />
                </div>
            </div>
            {!['au'].includes(locale) && <EfSpec />}
        </section>
    );
}
